import { AccountModel } from "@verivest/shared-components/src/api/models";
import { validateAllAttributesExistInData } from "./validateAllAttributesExistInData";
import { validateIndividualReqAttr } from "./validateIndividualReqAttr";

export const validateJointReqAttr = (
  joint: AccountModel | null | undefined,
) => {
  if (!joint) {
    return false;
  }

  const isIndividual1Valid = validateIndividualReqAttr(joint.individual1);
  const isIndividual2Valid = validateIndividualReqAttr(joint.individual2);

  const jointRequiredAttr: Array<keyof AccountModel> = ["investingWithSpouse"];
  const isJointValid = validateAllAttributesExistInData(
    jointRequiredAttr,
    joint,
  );

  return isJointValid && isIndividual1Valid && isIndividual2Valid;
};
